import React from 'react';
import styles from './GrillaResponsiva.module.css';

/**
 * Componente contenedor reutilizable para layouts responsivos de 2 columnas
 *
 * Desktop (≥1024px): 2 columnas lado a lado
 * Tablet (768-1024px): 1 columna (90% ancho)
 * Mobile (<768px): 1 columna fullwidth (100%)
 *
 * Props:
 * - items: Array de objetos con id y componente a renderizar
 *   ej: [{ id: 'datos', componente: <MiComponente /> }, ...]
 * - columnaSeparada: (opcional) índice de columna (para un componente en columna separada)
 *   Si se especifica, ese elemento se muestra en columna derecha en desktop
 */
const GrillaResponsiva = ({ items = [], columnaSeparada = -1 }) => {
  if (!items || items.length === 0) {
    return null;
  }

  // Separar items entre columna izquierda y derecha
  const itemsIzquierda =
    columnaSeparada >= 0
      ? items.slice(0, columnaSeparada)
      : items.slice(0, Math.ceil(items.length / 2));

  const itemsDerecha =
    columnaSeparada >= 0 ? items.slice(columnaSeparada) : items.slice(Math.ceil(items.length / 2));

  return (
    <div className={styles.grilla}>
      <div className={styles.columnaIzquierda}>
        {itemsIzquierda.map((item) => (
          <div key={item.id} className={styles.itemGrilla}>
            {item.componente}
          </div>
        ))}
      </div>

      {itemsDerecha.length > 0 && (
        <div className={styles.columnaDerecha}>
          {itemsDerecha.map((item) => (
            <div key={item.id} className={styles.itemGrilla}>
              {item.componente}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default GrillaResponsiva;
